const removeCustom = (fields) => Object.keys(fields).reduce((acc, key) => {
  const newKey = key.replace('custom_', '');

  return {
    ...acc,
    [newKey]: fields[key],
  };
}, {})

export default removeCustom;